import React, { useState, useEffect, useRef } from "react"

import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Layout from "../components/layout"
import Seo from "../components/seo"
import { SideSheet, Popover, Dialog, Tablist, CreditCardIcon, PersonIcon, TagIcon, SmallTickIcon, AntennaIcon, CodeIcon, NewPersonIcon, DuplicateIcon, CommentIcon, SendMessageIcon, CalendarIcon, DoughnutChartIcon, FollowingIcon, StopIcon, UpdatedIcon, FollowerIcon, GlobeNetworkIcon, EnvelopeIcon, PropertyIcon, TimeIcon, SegmentedControl, TextInput, SymbolCircleIcon, NewTextBoxIcon, TimelineEventsIcon, NumericalIcon, TextHighlightIcon, TagInput, Nudge, PieChartIcon, FloppyDiskIcon, ConfirmIcon, ExchangeIcon, ChevronLeftIcon, ChevronRightIcon, CloudDownloadIcon, CloudUploadIcon, DeleteIcon, ImportIcon, ChevronDownIcon, HeartIcon, ColumnLayoutIcon, IssueIcon, Pulsar, HeartBrokenIcon, BlockedPersonIcon, Paragraph, FileUploader, TextareaField, EmptyState, RefreshIcon, ShareIcon, LockIcon, SearchIcon, SearchInput, PlayIcon, PauseIcon, RepeatIcon, InlineAlert, CrossIcon, Badge, Textarea, Spinner, FileCard, HighlightIcon, Pagination, Table, Tab, SidebarTab, Pill, Heading, Label, Strong, Select, Overlay, Checkbox, TickIcon, InfoSignIcon, Tooltip, EyeOpenIcon, DisableIcon, MoreIcon, StatusIndicator, IconButton, RadioGroup, Radio, TextInputField, SelectMenu, SelectField, Combobox, PlusIcon, toaster, Alert, Avatar, Position, Menu, PeopleIcon, CircleArrowRightIcon, EditIcon, TrashIcon, Button, Pane, Portal, Switch, Text, majorScale } from 'evergreen-ui'

import Automationworkflow from "../static/automation.png";
import AiGenerated from "../static/aigenerated.svg";
import Reportssvg from "../static/reportssvg.svg";
import Cdp from "../static/cdp.png";
import Omnichannel from "../static/omnichannel.png";
import Transactionalmessage from "../static/transactionalmessage.png";
import Segmentimage from "../static/segmentimage.png";
import Teamimage from "../static/teamimage.png";

import Company1 from "../static/comp1.png";
import Company2 from "../static/comp2.svg";
import Company4 from "../static/comp4.png";
import Company5 from "../static/comp8.svg";
import Company6 from "../static/comp6.png";
import Comp7 from "../static/comp7.svg";



import { useInView } from 'react-intersection-observer';  




function IndexPage() {



const sections = [  
  { title: 'Manage your audiences and segments', text: 'Whether you have multiple businesses or you want to separate your sources of data, you can create audiences and highly specific segments for more accurate communication.', imageUrl: Segmentimage },  
  { title: 'Send transactional emails', text: 'With no addons required, you can send your password reset notifications and all types of transactional messages with a single API call.', imageUrl: Transactionalmessage },  
  { title: 'Collaborate with your team', text: 'Invite your team members and assign them roles to seamlessly work together.', imageUrl: Teamimage },  
];  


 
 
 
 
 
 
  const [activeSection, setActiveSection] = useState(0);  
  
  // Refs for the sections  
  const sectionRefs = useRef([]);  
  sectionRefs.current = [];  
  
  // Adding refs dynamically  
  const addToRefs = (el) => {  
    if (el && !sectionRefs.current.includes(el)) {  
      sectionRefs.current.push(el);  
    }  
  };  
  
  useEffect(() => {  

    const observer = new IntersectionObserver(  
      (entries) => {  
        entries.forEach((entry) => {  
          if (entry.isIntersecting) {  
            const index = sectionRefs.current.indexOf(entry.target);  
            setActiveSection(index);  
          }  
        });  
      },  
      {  
        rootMargin: '0px',  
        threshold: 0.6, // Adjust this value based on when you want to switch images  
      }  
    );  
  
    sectionRefs.current.forEach((section) => {  
      observer.observe(section);  
    });  
  
    return () => {  
      sectionRefs.current.forEach((section) => {  
        observer.unobserve(section);  
      });  
    };  
  }, []);  
 


  
return(


  <Layout>
    <section>
		<Pane className="py-6 lg:py-20 mainback relative">
			<div className="absolute z-0 overflow-hidden right-0">
				<svg className="relative -right-[41%] opacity-[0.34]" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" xmlnsSvgjs="http://svgjs.dev/svgjs" width="1400" height="900" preserveAspectRatio="none" viewBox="0 0 1100 700">
					<g mask="url(&quot;#SvgjsMask1639&quot;)" fill="none">
						<path d="M45.59 -39.74L86.29 -16.24L86.29 30.76L45.59 54.26L4.89 30.76L4.89 -16.24zM86.29 171.76L127 195.26L127 242.26L86.29 265.76L45.59 242.26L45.59 195.26zM86.29 594.76L127 618.26L127 665.26L86.29 688.76L45.59 665.26L45.59 618.26zM45.59 665.26L86.29 688.76L86.29 735.76L45.59 759.26L4.89 735.76L4.89 688.76zM127 -39.74L167.7 -16.24L167.7 30.76L127 54.26L86.29 30.76L86.29 -16.24zM167.7 171.76L208.41 195.26L208.41 242.26L167.7 265.76L127 242.26L127 195.26zM249.11 30.76L289.82 54.26L289.82 101.26L249.11 124.76L208.41 101.26L208.41 54.26zM249.11 312.76L289.82 336.26L289.82 383.26L249.11 406.76L208.41 383.26L208.41 336.26zM208.41 665.26L249.11 688.76L249.11 735.76L208.41 759.26L167.7 735.76L167.7 688.76zM289.82 665.26L330.52 688.76L330.52 735.76L289.82 759.26L249.11 735.76L249.11 688.76zM411.93 30.76L452.63 54.26L452.63 101.26L411.93 124.76L371.22 101.26L371.22 54.26zM371.22 524.26L411.93 547.76L411.93 594.76L371.22 618.26L330.52 594.76L330.52 547.76zM452.63 -39.74L493.34 -16.24L493.34 30.76L452.63 54.26L411.93 30.76L411.93 -16.24zM452.63 101.26L493.34 124.76L493.34 171.76L452.63 195.26L411.93 171.76L411.93 124.76zM493.34 312.76L534.04 336.26L534.04 383.26L493.34 406.76L452.63 383.26L452.63 336.26zM534.04 101.26L574.75 124.76L574.75 171.76L534.04 195.26L493.34 171.76L493.34 124.76zM574.75 312.76L615.45 336.26L615.45 383.26L574.75 406.76L534.04 383.26L534.04 336.26zM574.75 453.76L615.45 477.26L615.45 524.26L574.75 547.76L534.04 524.26L534.04 477.26zM534.04 665.26L574.75 688.76L574.75 735.76L534.04 759.26L493.34 735.76L493.34 688.76zM656.16 171.76L696.86 195.26L696.86 242.26L656.16 265.76L615.45 242.26L615.45 195.26zM615.45 242.26L656.16 265.76L656.16 312.76L615.45 336.26L574.75 312.76L574.75 265.76zM737.56 30.76L778.27 54.26L778.27 101.26L737.56 124.76L696.86 101.26L696.86 54.26zM696.86 242.26L737.56 265.76L737.56 312.76L696.86 336.26L656.16 312.76L656.16 265.76zM696.86 524.26L737.56 547.76L737.56 594.76L696.86 618.26L656.16 594.76L656.16 547.76zM818.97 30.76L859.68 54.26L859.68 101.26L818.97 124.76L778.27 101.26L778.27 54.26zM778.27 242.26L818.97 265.76L818.97 312.76L778.27 336.26L737.56 312.76L737.56 265.76zM818.97 453.76L859.68 477.26L859.68 524.26L818.97 547.76L778.27 524.26L778.27 477.26zM900.38 30.76L941.09 54.26L941.09 101.26L900.38 124.76L859.68 101.26L859.68 54.26zM900.38 171.76L941.09 195.26L941.09 242.26L900.38 265.76L859.68 242.26L859.68 195.26zM900.38 453.76L941.09 477.26L941.09 524.26L900.38 547.76L859.68 524.26L859.68 477.26zM941.09 -39.74L981.79 -16.24L981.79 30.76L941.09 54.26L900.38 30.76L900.38 -16.24zM941.09 242.26L981.79 265.76L981.79 312.76L941.09 336.26L900.38 312.76L900.38 265.76zM981.79 312.76L1022.49 336.26L1022.49 383.26L981.79 406.76L941.09 383.26L941.09 336.26zM981.79 453.76L1022.49 477.26L1022.49 524.26L981.79 547.76L941.09 524.26L941.09 477.26zM1022.49 383.26L1063.2 406.76L1063.2 453.76L1022.49 477.26L981.79 453.76L981.79 406.76zM1022.49 524.26L1063.2 547.76L1063.2 594.76L1022.49 618.26L981.79 594.76L981.79 547.76zM1103.9 -39.74L1144.61 -16.24L1144.61 30.76L1103.9 54.26L1063.2 30.76L1063.2 -16.24zM1144.61 312.76L1185.31 336.26L1185.31 383.26L1144.61 406.76L1103.9 383.26L1103.9 336.26zM1103.9 383.26L1144.61 406.76L1144.61 453.76L1103.9 477.26L1063.2 453.76L1063.2 406.76zM1103.9 524.26L1144.61 547.76L1144.61 594.76L1103.9 618.26L1063.2 594.76L1063.2 547.76zM1103.9 665.26L1144.61 688.76L1144.61 735.76L1103.9 759.26L1063.2 735.76L1063.2 688.76z" stroke="url(&quot;#SvgjsLinearGradient1640&quot;)" strokeWidth="2"></path>
					</g>
					<defs>
						<mask id="SvgjsMask1639">
							<rect width="1100" height="700" fill="#ffffff"></rect>
						</mask>
						<linearGradient x1="0" y1="350" x2="1100" y2="350" gradientUnits="userSpaceOnUse" id="SvgjsLinearGradient1640">
							<stop stop-color="rgba(58, 193, 148, 0.22)" offset="0.09"></stop>
							<stop stop-color="rgba(0, 158, 138, 1)" offset="1"></stop>
						</linearGradient>
					</defs>
				</svg>
			</div>

		
			<div className="mx-auto relative max-w-7xl z-10 px-8 sm:px-6 lg:px-8">
		
				
					  <div className="mb-14 mt-[7rem] md:mt-16">
						  <h2 className="text-white !font-regular hidden md:block text-5xl md:text-5xl lg:text-7xl md:mx-auto md:text-center lg:font-medium md:font-medium text-gray-900 mb-4 max-w-max md:max-w-3xl lg:max-w-6xl lg:mx-auto bldspacing md:mn3-spacing lg:mn3-spacing bld-font">Engage your customers with marketing automation</h2>
						  <h2 className="text-white !font-regular md:hidden text-5xl md:text-5xl lg:text-7xl md:mx-auto md:text-center lg:font-medium md:font-medium text-gray-900 mb-4 max-w-max md:max-w-3xl lg:max-w-6xl lg:mx-auto bldspacing md:mn3-spacing lg:mn3-spacing bld-font">Powerful customer engagement</h2>
						  <p className="text-slate-300 text-xl font-regular text-black md:text-center md:max-w-xl lg:max-w-xl md:mx-auto lg:mx-auto mb-8">Create personalized data-driven journeys and send messages people actually want to receive.</p>  
						  <div className="flex md:justify-center md:flex-row gap-3 max-w-lg md:mx-auto sm:mx-0 md:max-w-2xl sm:max-w-full mb-6">   
							  <a href="https://app.dynosend.com/account/register" target="_blank" rel="noreferrer" className="dsndbtn dsndbtn-mbl dsndbtn-main bg-primary md:w-fit w-2/4 font-medium tx-white rounded-full lg:bigcta md:bigcta">Try for free</a>
							  <a href="/pricing" className="dsndbtn dsndbtn-mbl dsndbtn-accent dsndbtn-outline md:w-fit w-2/4 tx-white rounded-full font-medium lg:bigcta md:bigcta !text-white">See pricing</a>
						  </div>
						  <ul className="flex flex-col flex-nowrap gap-2 text-xs justify-center opacity-85 md:flex-row">
							<li className="flex items-center gap-2 text-nowrap cl-37a9a9">
								<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 11.0857V12.0057C21.9988 14.1621 21.3005 16.2604 20.0093 17.9875C18.7182 19.7147 16.9033 20.9782 14.8354 21.5896C12.7674 22.201 10.5573 22.1276 8.53447 21.3803C6.51168 20.633 4.78465 19.2518 3.61096 17.4428C2.43727 15.6338 1.87979 13.4938 2.02168 11.342C2.16356 9.19029 2.99721 7.14205 4.39828 5.5028C5.79935 3.86354 7.69279 2.72111 9.79619 2.24587C11.8996 1.77063 14.1003 1.98806 16.07 2.86572M22 4L12 14.01L9 11.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"></path></svg>
								14-day free trial
							</li>
							<li className="flex items-center gap-2 text-nowrap cl-37a9a9">
								<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 11.0857V12.0057C21.9988 14.1621 21.3005 16.2604 20.0093 17.9875C18.7182 19.7147 16.9033 20.9782 14.8354 21.5896C12.7674 22.201 10.5573 22.1276 8.53447 21.3803C6.51168 20.633 4.78465 19.2518 3.61096 17.4428C2.43727 15.6338 1.87979 13.4938 2.02168 11.342C2.16356 9.19029 2.99721 7.14205 4.39828 5.5028C5.79935 3.86354 7.69279 2.72111 9.79619 2.24587C11.8996 1.77063 14.1003 1.98806 16.07 2.86572M22 4L12 14.01L9 11.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"></path></svg>
								No credit card required
							</li>
							<li className="flex items-center gap-2 text-nowrap cl-37a9a9">
								<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 11.0857V12.0057C21.9988 14.1621 21.3005 16.2604 20.0093 17.9875C18.7182 19.7147 16.9033 20.9782 14.8354 21.5896C12.7674 22.201 10.5573 22.1276 8.53447 21.3803C6.51168 20.633 4.78465 19.2518 3.61096 17.4428C2.43727 15.6338 1.87979 13.4938 2.02168 11.342C2.16356 9.19029 2.99721 7.14205 4.39828 5.5028C5.79935 3.86354 7.69279 2.72111 9.79619 2.24587C11.8996 1.77063 14.1003 1.98806 16.07 2.86572M22 4L12 14.01L9 11.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"></path></svg>
								Instant setup
							</li>
						  </ul>
						</div>
				
			
	
	
				<div className="relative z-10 w-full h-auto transition-transform ease-linear">
					<img alt="Marketing automation flow" src="https://dynosend.com/static/workflow.png" decoding="async" className="relative mx-auto w-full max-w-6xl md:rounded-xl shadow-xl" style={{"color":"transparent", "boxShadow":"rgb(70 75 78 / 16%) 0px 4px 25px"}} />
				</div>
					 
		
			
			</div>
	
	
			<div className="max-w-[85rem] px-8 pt-10 sm:px-6 lg:px-8 lg:py-20 !pb-0 mx-auto">
			  <div className="hidden md:block w-2/3 sm:w-1/2 lg:w-1/3 mx-auto text-center mb-5">
				<h2 className="text-gray-400 text-sm font-medium">Trusted by companies and organizations like you</h2>
			  </div>
			  <div className="grid grid-rows-2 lg:grid md:grid lg:grid-rows-1 md:grid-rows-1 grid-flow-col justify-center items-center gap-x-6 sm:gap-x-12 lg:gap-x-12 place-items-center">
				<img height="100%" width="100%" alt="Fitcorpgroup Logo" className="h-fit md:w-20 lg:w-24 text-gray-500 opacity-60" src={Company1} draggable={false}></img>
				<img height="100%" width="100%" alt="atmedia logo" className="h-fit md:w-20 lg:w-24 text-gray-500 opacity-60" src={Company2} draggable={false}></img>
				<img height="100%" width="100%" alt="Vackground logo" className="h-fit md:w-20 lg:w-24 text-gray-500 opacity-60" src={Company5} draggable={false}></img>
				<img height="100%" width="100%" alt="Skilltimate logo" className="h-fit md:w-20 lg:w-24 text-gray-500 opacity-50" src={Company4} draggable={false}></img>
				<img height="100%" width="100%" alt="One Billion Literates Foundation logo" className="h-fit md:w-20 lg:w-24 text-gray-500 opacity-60 max-w-20" src={Company6} draggable={false}></img>
				<img height="100%" width="100%" alt="BAX-U logo" className="h-fit md:w-20 lg:w-24 text-gray-500 opacity-60 max-w-14" src={Comp7} draggable={false}></img>
			 </div>
			</div>
		
	 

		</Pane>
	</section>
	
	<section className="py-6 lg:py-12">
        <div className="mx-auto mt-7 md:mt-10 lg:mt-10 max-w-7xl px-8 sm:px-6 lg:px-8">
		
              <div>
                  <h1 className="text-4xl md:text-4xl lg:text-5xl text-center mx-auto font-medium cl-083136 mb-2 max-w-max md:max-w-3xl lg:max-w-6xl lg:mx-auto bldspacing md:mn2-spacing lg:mn2-spacing">Create engaging journeys</h1>
				  <p className="text-xl font-normal mt-7 text-center text-slate-700 md:text-center md:max-w-xl lg:max-w-3xl mx-auto mb-10">Create unique data-driven customer experiences via email and SMS and engage your customers from their first day.</p>  
              </div>

	
		
	
			<div className="max-w-[70rem] mx-auto mt-16">
			  <div className="flex flex-col lg:grid md:grid lg:grid-rows-2 md:grid-rows-3 grid-flow-col gap-6">
				
				<div className="shadow-bg row-span-2 transition-transform ease-linear group flex flex-col h-full border border-slate-100 shadow-sm rounded-xl overflow-hidden justify-between">
				  <div className="p-4 md:p-6">
					<h3 className="text-hxl font-bold cl-083136 ">
					  Visual workflow builder
					</h3>
					<p className="mt-0.5 text-gray-500">
					  An easy to use builder to craft journeys the way you want them to be
					</p>
				  </div>
				  <div className="h-fit w-full flex flex-col justify-center items-center relative overflow-hidden">
						<img height="100%" width="100%" alt="Marketing automation workflow builder" src={Automationworkflow} draggable={false}></img>
				  </div>
				</div>
				
				<div className="shadow-bg  transition-transform ease-linear group flex flex-col border border-slate-100 shadow-sm rounded-xl overflow-hidden justify-between">
				  <div className="p-4 md:p-6">
					<h3 className="text-hxl font-bold cl-083136 ">
					  Customer Data Platform
					</h3>
					<p className="mt-0.5 text-gray-500">
					  Integrate your own application and manage your customer data
					</p>
				  </div>
				  <div className="h-fit w-full flex flex-col justify-center items-center relative overflow-hidden">
						<img height="100%" width="100%" alt="Customer data platform" src={Cdp} draggable={false}></img>
				  </div>
				</div>
				<div className="shadow-bg transition-transform ease-linear group flex flex-col border border-slate-100 shadow-sm rounded-xl overflow-hidden justify-between">
				  <div className="p-4 md:p-6">
					<h3 className="text-hxl font-bold cl-083136 ">
					  Reports
					</h3>
					<p className="mt-0.5 text-gray-500">
					  Understand, visualize and analyze your marketing efforts
					</p>
				  </div>
				  <div className="h-full w-full flex flex-col justify-center items-center relative overflow-hidden">
						<img height="100%" width="100%" alt="Marketing reports" src={Reportssvg} draggable={false}></img>
				  </div>
				</div>
				
				<div className="shadow-bg transition-transform ease-linear group flex flex-col border border-slate-100 shadow-sm rounded-xl overflow-hidden justify-between">
				  <div className="p-4 md:p-6">
					<h3 className="text-hxl font-bold cl-083136 ">
					 AI-enhanced
					</h3>
					<p className="mt-0.5 text-gray-500">
					  Save time and improve your messaging with integrated AI tools
					</p>
				  </div>
				  <div className="h-full w-full flex flex-col justify-center items-center relative overflow-hidden">
						<img height="100%" width="100%" alt="AI generated subject lines" src={AiGenerated} draggable={false}></img>
				  </div>
				</div>
				
				<div className="shadow-bg transition-transform ease-linear group flex flex-col border border-slate-100 shadow-sm rounded-xl overflow-hidden justify-between">
				  <div className="p-4 md:p-6">
					<h3 className="text-hxl font-bold cl-083136 ">
					  Omnichannel
					</h3>
					<p className="mt-0.5 text-gray-500">
					  Reach your customers across different channels: email, SMS and more
					</p>
				  </div>
				  <div className="h-full w-full flex flex-col justify-center items-center relative overflow-hidden">
						<img height="100%" width="100%" alt="Omnichannel marketing" src={Omnichannel} draggable={false}></img>
				  </div>
				</div>
				
				
				
			
				
			
				
				
			  </div>
			</div>
		
		

		</div>
    </section>

	
		<div className="block lg:block max-w-[74rem] px-8 py-10 sm:px-6 lg:px-8 lg:py-20 lg:pb-32 mx-auto">
		  <div className="relative">

			<div className="relative z-10 lg:grid lg:grid-cols-12 lg:gap-10 lg:items-center">
			  <div className="mb-10 lg:mb-0 lg:col-span-6 lg:col-start-8 lg:order-2">
				<h2 className="text-2xl text-gray-800 font-bold sm:text-3xl">
				  Helping you scale and meet your goals
				</h2>

				<nav className="grid gap-4 mt-5 md:mt-10" aria-label="Tabs" role="tablist">
				  <button type="button" className="hs-tab-active:bg-white hs-tab-active:shadow-md hs-tab-active:hover:border-transparent text-start hover:bg-gray-200 p-4 md:p-5 rounded-xl active" id="tabs-with-card-item-1" data-hs-tab="#tabs-with-card-1" aria-controls="tabs-with-card-1" role="tab">
					<span className="flex">
					  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="flex-shrink-0 size-6 md:size-7 hs-tab-active:text-blue-600 text-gray-800"><path strokeLinecap="round" strokeLinejoin="round" d="M10.5 6a7.5 7.5 0 1 0 7.5 7.5h-7.5V6Z" /><path strokeLinecap="round" strokeLinejoin="round" d="M13.5 10.5H21A7.5 7.5 0 0 0 13.5 3v7.5Z" /></svg>
					  <span className="grow ms-6">
						<span className="block text-lg font-semibold hs-tab-active:text-blue-600 text-gray-800">Manage your audiences and segments</span>
						<span className="block mt-1 text-gray-800">Whether you have multiple businesses or you want to separate your sources of data, you can create audiences and highly specific segments for more accurate communication.</span>
					  </span>
					</span>
				  </button>

				  <button type="button" className="hs-tab-active:bg-white hs-tab-active:shadow-md hs-tab-active:hover:border-transparent text-start hover:bg-gray-200 p-4 md:p-5 rounded-xl" id="tabs-with-card-item-2" data-hs-tab="#tabs-with-card-2" aria-controls="tabs-with-card-2" role="tab">
					<span className="flex">
					  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="flex-shrink-0 size-6 md:size-7 hs-tab-active:text-blue-600 text-gray-800"><path strokeLinecap="round" strokeLinejoin="round" d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5" /></svg>
					  <span className="grow ms-6">
						<span className="block text-lg font-semibold hs-tab-active:text-blue-600 text-gray-800">Send transactional emails</span>
						<span className="block mt-1 text-gray-800">With no addons required, you can send your password reset notifications and all types of transactional messages with a single API call.</span>
					  </span>
					</span>
				  </button>

				  <button type="button" className="hs-tab-active:bg-white hs-tab-active:shadow-md hs-tab-active:hover:border-transparent text-start hover:bg-gray-200 p-4 md:p-5 rounded-xl" id="tabs-with-card-item-3" data-hs-tab="#tabs-with-card-3" aria-controls="tabs-with-card-3" role="tab">
					<span className="flex">
					  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="flex-shrink-0 size-6 md:size-7 hs-tab-active:text-blue-600 text-gray-800"><path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" /></svg>
					  <span className="grow ms-6">
						<span className="block text-lg font-semibold hs-tab-active:text-blue-600 text-gray-800">Collaborate with your team</span>
						<span className="block mt-1 text-gray-800">Invite your team members and assign them roles to seamlessly work together.</span>
					  </span>
					</span>
				  </button>
				</nav>

			  </div>


			  <div className="lg:col-span-6">
				<div className="relative">

				  <div>
					<div id="tabs-with-card-1" role="tabpanel" aria-labelledby="tabs-with-card-item-1">
					  <img className="shadow-xl shadow-gray-200 rounded-xl" src={Segmentimage} alt="Segments" />
					</div>

					<div id="tabs-with-card-2" className="hidden" role="tabpanel" aria-labelledby="tabs-with-card-item-2">
					  <img className="shadow-xl shadow-gray-200 rounded-xl" src={Transactionalmessage} alt="Transactional messages" />
					</div>

					<div id="tabs-with-card-3" className="hidden" role="tabpanel" aria-labelledby="tabs-with-card-item-3">
					  <img className="shadow-xl shadow-gray-200 rounded-xl" src={Teamimage} alt="Team collaboration" />
					</div>
				  </div>

			   

				</div>
			  </div>

			</div>



		  </div>
		</div>


	
	
	<section className="bg-02464e py-24 lg:py-32 px-8">
	  <div className="container mx-auto">
		<div className="lg:px-20">
		  <div className="text-center flex flex-col items-center">
			<h2 className="text-4xl font-bold mb-6 text-white">A platform you can rely on</h2>
			<p className="text-xl mx-auto max-w-screen-md text-gray-400">We aim to make sure your communication with your customers will not be interrupted, and we'll assist you quickly if anything goes south!</p>
			<div className="grid grid-cols-2 sm:grid-cols-3 max-w-screen-lg sm:divide-x-2 divide-gray-400 divide-opacity-10 mx-auto mt-10">
			  <div className="flex flex-col p-4">
				<span className="text-2xl lg:text-4xl font-bold dmsans text-white">99.99%</span>
				<span className="opacity-70 leading-none text-medium text-gray-400">platform uptime</span>
			  </div>
			  <div className="flex flex-col p-4">
				<span className="text-2xl lg:text-4xl font-bold dmsans text-white">98%</span>
				<span className="opacity-70 leading-none text-medium text-gray-400">satisfaction rate</span>
			  </div>
			  <div className="col-span-2 sm:col-span-1 flex flex-col p-4">
				<span className="text-2xl lg:text-4xl font-bold dmsans text-white">1 hr</span>
				<span className="opacity-70 leading-none text-medium text-gray-400">avg. response time on email</span>
			  </div>
			</div>
		  </div>
		</div>
	  </div>
	</section>
	
	
  </Layout>
);
}


export const Head = () => <Seo 
	title="Customer Engagement Platform, Email Marketing and CDP" 
	description="Engage your customers with marketing automation. Create journeys, send transactional messages and manage your customer data." 
	base="/"
/>

export default IndexPage
